export const HOMES_CONTACT_INFO_TITLE = "Contact Host";
export const HOMES_CONTACT_INFO_SUBTITLE =
  "Get in touch with your host regarding check-in, check-out, etc.";
export const HOMES_CONTACT_INFO_EMAIL = "Email address";
export const HOMES_CONTACT_INFO_PHONE_NUMBER = "Phone number";
